module.exports = __webpack_public_path__ + "img/weixin_3.1552eb8d.png";